// extracted by mini-css-extract-plugin
export var content = "fc-content-with-image-module--content--5c66a";
export var contentWrap = "fc-content-with-image-module--contentWrap--f7556";
export var grid = "fc-content-with-image-module--grid--6c266";
export var image = "fc-content-with-image-module--image--e6062";
export var root = "fc-content-with-image-module--root--b0c60";
export var subtitle = "fc-content-with-image-module--subtitle--d99cb";
export var text = "fc-content-with-image-module--text--769e0";
export var title = "fc-content-with-image-module--title--57fcf";